/**
 * JS handle functions for announcements
 *
 * @since 4.0.2
 * @version 1.0.0
 */

import * as Util from './utils.js';

const classListAnnouncement = '.lp-announcements-list';
const classBtnLoadMore = '.announcement-btn-load-more';

// Events
// Click
document.addEventListener( 'click', ( e ) => {
	const target = e.target;

	toggleCollapse( target, e );
	loadMore( target, e );
} );

// Toggle collapse for announcement sections
const toggleCollapse = ( target, e ) => {
	const elHeader = target.closest( '.announcement-header' );
	if ( ! elHeader ) {
		return;
	}

	const elLi = target.closest( '.announcement' );

	// Toggle section
	elLi.classList.toggle( 'lp-collapse' );
};

// Load more announcements
const loadMore = ( target, e ) => {
	const elBtnLoadMore = target.closest( `${ classBtnLoadMore }` );
	if ( ! elBtnLoadMore ) {
		return;
	}

	const lpTarget = elBtnLoadMore.closest( '.lp-target' );
	const dataSend = window.lpAJAXG.getDataSetCurrent( lpTarget );
	dataSend.args.paged++;

	Util.lpSetLoadingEl( elBtnLoadMore, 1 );

	const callBack = {
		success: ( response ) => {
			const { status, message, data } = response;
			if ( status === 'success' ) {
				const newEl = document.createElement( 'div' );
				newEl.innerHTML = data.content || '';
				const elList = lpTarget.querySelector(
					`${ classListAnnouncement }`
				);
				elList.insertAdjacentHTML(
					'beforeend',
					newEl.querySelector( classListAnnouncement ).innerHTML
				);

				const elBtnLoadMoreFind = newEl.querySelector(
					`${ classBtnLoadMore }`
				);
				if ( ! elBtnLoadMoreFind ) {
					elBtnLoadMore.remove();
				}

				window.lpAJAXG.setDataSetCurrent( lpTarget, dataSend );
			} else {
				console.error( message );
			}
		},
		error: ( error ) => {
			console.error( error );
		},
		completed: () => {
			Util.lpSetLoadingEl( elBtnLoadMore, 0 );
		},
	};
	window.lpAJAXG.fetchAJAX( dataSend, callBack );
};
